import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-delete-student-support-article',
    template: `
        <ng-container i18n="@@support.articles.deleteStudent">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/students">Students Overview</a>.</span>
                </li>
                <li>
                    <span>Find the student in the list or use the search field to find the student.</span>
                </li>
                <li>
                    <span>
                        Click the three dots on the right side of the student.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/deleteStudentBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click on <strong>Delete</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <span>
                        Confirm by clicking <strong>Delete</strong> again in the dialog that opens.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/deleteStudent.png" />
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class DeleteStudentSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
